export const DEVICE_AVAILABILITY_ROUTE = '/devices/availability';
// 400 bad window, 403 device out of scope, 404 unknown device, 422 interval history too large.
export const DEVICE_AVAILABILITY_EXPECTED_HTTP_STATUSES = [400, 403, 404, 422] as const;
// Mirror the backend availability limits; the backend stays authoritative and re-checks both.
export const DEVICE_AVAILABILITY_MAX_DEVICES = 100;
export const DEVICE_AVAILABILITY_MAX_RANGE_DAYS = 31;
// An open-ended window is judged against a clock that is re-sampled at this cadence.
export const DEVICE_AVAILABILITY_NOW_REFRESH_MS = 60_000;
